var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPlug(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.80716 0.344388C10.5959 -0.255526 14.233 2.05017 15.3864 5.74886C16.5387 9.4439 14.8775 13.4531 11.4519 15.1865C11.0823 15.3735 10.6311 15.2255 10.4441 14.8559C10.257 14.4863 10.405 14.0351 10.7746 13.8481C13.5335 12.452 14.893 9.20497 13.9544 6.19543C13.017 3.18954 10.0766 1.34539 7.04175 1.82593C4.00461 2.30684 1.74756 4.97771 1.75 8.13618V8.13738C1.74853 9.9117 2.44066 11.6109 3.66916 12.8602C4.5478 13.7518 5.7344 14.2499 6.96839 14.2499C7.11178 14.2495 7.25136 14.1271 7.25149 13.9469V11.3068C7.25149 10.8926 7.58728 10.5568 8.00149 10.5568C8.41571 10.5568 8.75149 10.8926 8.75149 11.3068V13.9475C8.75077 14.9292 7.96616 15.7492 6.96896 15.7499C5.32886 15.7499 3.75797 15.0875 2.60044 13.9128C1.09286 12.3797 0.248353 10.3008 0.250002 8.13671C0.247304 4.26066 3.02098 0.943902 6.80716 0.344388Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 7.72727C4.25 6.80059 5.0898 6.25 5.85714 6.25H10.1429C10.9102 6.25 11.75 6.80059 11.75 7.72727V9.54545C11.75 10.8738 10.5264 11.75 9.28571 11.75H6.71429C5.47356 11.75 4.25 10.8738 4.25 9.54545V7.72727ZM5.75 7.77543V9.54545C5.75 9.82376 6.06147 10.25 6.71429 10.25H9.28571C9.93853 10.25 10.25 9.82376 10.25 9.54545V7.77543C10.23 7.76377 10.1942 7.75 10.1429 7.75H5.85714C5.80575 7.75 5.77001 7.76377 5.75 7.77543Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3.75C6.41421 3.75 6.75 4.08579 6.75 4.5V7C6.75 7.41421 6.41421 7.75 6 7.75C5.58579 7.75 5.25 7.41421 5.25 7V4.5C5.25 4.08579 5.58579 3.75 6 3.75ZM10 3.75C10.4142 3.75 10.75 4.08579 10.75 4.5V7C10.75 7.41421 10.4142 7.75 10 7.75C9.58579 7.75 9.25 7.41421 9.25 7V4.5C9.25 4.08579 9.58579 3.75 10 3.75Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlug);
export default __webpack_public_path__ + "static/media/icon-plug.3dd8760c930ace18086bcb71f58fc95a.svg";
export { ForwardRef as ReactComponent };